/**
 * Create store system routing-static
 *
 * @since 2018-06-25
 * @author jongsung.Lee(devp010)
 */

import {SystemApiPrefix as smApiPrefix} from 'utils'

export const plugins = [Plugin]

export const state = () => ({
  // axios api's urls
  apiUrlPath: {
    // static routing
    staticRoutings: `${smApiPrefix}/static-routings`,
    staticRouteCandidates: `${smApiPrefix}/static-routings/interface-candidates`,
    dynamicRoutings: `${smApiPrefix}/dynamic-routings`,
    directRoutings: `${smApiPrefix}/direct-routings`
  },
  // Search
  routingSearch: {
    selectItem: 'ip', // ip or gw
    searchWord: ''
  },
  // CRUD state.
  selectedItem: {},
  selectedPopupItem: {},
  // 정적 라우팅 목록을 조회
  staticRouting: {
    id: 0, //           id
    type: 0, //         디폴트 게이트웨이: 0, 특정 네트워크 게이트웨이: 1
    multipath: 0, //    다중경로 라우팅(OFF: 0, ON: 1)
    dest_addr: '', //   목적지 주소(디폴트:0.0.0.0/0, IPv4 Address)
    dest_mask: 0, //    목적지 주소 mask(Bit Mask)
    metric: 0, //       메트릭
    flags: '', //        flag( from cli )
    gw: [], //            게이트웨이 목록(목록에서는 문자열로 표기)
    gwTostring: '', //  검색용 속성(api에 없음)
    desc: '' //         라우팅 설명
  },
  staticRoutingGw: {
    id: 0,
    addr: '', //      게이트웨이 주소
    ifc_id: 0, //     게이트웨이 인터페이스 ID
    ifc_name: '', //  게이트웨이 인터페이스 이름
    weight: 1 //      가중치
  },
  gatewayCandidates: [],
  staticRoutingList: [],
  staticRoutingListCnt: 1,
  dynamicRouting: {
    id: 0,
    dest: '', //       목적지(ipv4/mask)
    metric: 0, //     메트릭
    flags: '', //     플래그
    gw: '', //        게이트웨이(IPv4)
    interface: '' //  인터페이스
  },
  dynamicRoutingList: [],
  directRouting: {
    id: 0,
    dest: '', //       목적지(ipv4/mask)
    metric: 0, //     메트릭
    flags: '', //     플래그
    gw: '', //        게이트웨이(IPv4)
    interface: '' //  인터페이스
  },
  directRoutingList: []
})

export const mutations = {
  resetRoutingSearch (state) {
    state.routingSearch.selectItem = 'ip'
    state.routingSearch.searchWord = ''
  },
  setRoutingSearch (state, item) {
    state.routingSearch.selectItem = item.selectItem
    state.routingSearch.searchWord = item.searchWord
  },
  resetSelectedItem (state) {
    state.selectedItem = {}
  },
  setSelectedItem (state, item) {
    state.selectedItem = item
  },
  resetSelectedPopupItem (state) {
    state.selectedPopupItem = {}
  },
  setSelectedPopupItem (state, item) {
    state.selectedPopupItem = item
  },
  // reset list
  resetStaticRoutingList (state) {
    state.staticRoutingList = []
  },
  resetStaticRoutingGwList (state) {
    state.staticRouting.gw = []
  },
  resetDynamicRoutingList (state) {
    state.dynamicRoutingList = []
  },
  resetDirectRoutingList (state) {
    state.directRoutingList = []
  },
  // set list
  setStaticRoutingList (state, data) {
    if (data !== undefined && data.length > 0) {
      state.staticRoutingList = data
    }
  },
  setDynamicRoutingList (state, data) {
    if (data !== undefined && data.length > 0) {
      state.dynamicRoutingList = data
    }
  },
  setDirectRoutingList (state, data) {
    if (data !== undefined && data.length > 0) {
      state.directRoutingList = data
    }
  },
  setStaticRoutingListCnt (state) {
    state.staticRoutingListCnt = state.staticRoutingList.length
  },
  // add & edit & delete static routing
  addStaticRoutingList (state, item) {
    if (item !== undefined) {
      state.staticRoutingList.push(item)
    }
  },
  edtStaticRoutingList (state, item) {
    const findRslt = _.find(state.staticRoutingList, {id: item.id})
    if (findRslt !== undefined && findRslt.itemIndex !== undefined) {
      state.staticRoutingList.splice(_.findIndex(state.staticRoutingList, state.selectedItem), 1, item)
    }
  },
  delStaticRoutingList (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.staticRoutingList.splice(item.itemIndex, 1)
      }
    }
  },
  // add, edit, delete staticRouting gateway
  addStaticRoutingGw (state, item) {
    state.staticRouting.gw.push(item)
  },
  editStaticRoutingGw (state, item) {
    const findRslt = _.find(state.staticRouting.gw, {id: item.id})
    if (findRslt !== undefined && findRslt.itemIndex !== undefined) {
      state.staticRouting.gw.splice(_.findIndex(state.staticRouting.gw, state.selectedPopupItem), 1, item)
    }
  },
  delStaticRoutingGw (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.staticRouting.gw.splice(item.itemIndex, 1)
      }
    }
  },
  // set dialog
  clearStaticRoutingEntryDialog (state) {
    state.staticRouting.id = 0
    state.staticRouting.type = 0
    state.staticRouting.multipath = 0
    state.staticRouting.dest_addr = ''
    state.staticRouting.dest_mask = 0
    state.staticRouting.metric = 0
    state.staticRouting.flag = ''
    state.staticRouting.gw = []
    state.staticRouting.desc = ''
  },
  setStaticRoutingEntryDialog (state, item) {
    if (item !== undefined) {
      state.staticRouting.id = item.id
      state.staticRouting.type = item.type
      state.staticRouting.multipath = item.multipath
      state.staticRouting.dest_addr = item.dest_addr
      state.staticRouting.dest_mask = item.dest_mask
      state.staticRouting.metric = item.metric
      state.staticRouting.flag = item.flag
      state.staticRouting.gw = _.cloneDeep(item.gw)
      state.staticRouting.desc = item.desc
    }
  },
  clearStaticRoutingGwDialog (state) {
    state.staticRoutingGw.id = 0
    state.staticRoutingGw.addr = null
    state.staticRoutingGw.ifc_id = 0
    state.staticRoutingGw.ifc_name = ''
    state.staticRoutingGw.weight = 1
  },
  setStaticRoutingGwDialog (state, item) {
    if (item !== undefined) {
      state.staticRoutingGw.id = item.id
      state.staticRoutingGw.addr = item.addr
      state.staticRoutingGw.ifc_id = item.ifc_id
      state.staticRoutingGw.ifc_name = item.ifc_name
      state.staticRoutingGw.weight = (item.weight === 0) ? 1 : item.weight
    }
  },
  // set candidates
  setStaticRouteCandidates (state, items) {
    state.gatewayCandidates = []
    if (items !== undefined && items.length > 0) {
      for (const candi of items) {
        state.gatewayCandidates.push({
          label: candi.name,
          value: candi.id
        })
      }
    }
  }
}

export const actions = {
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> static routing
  async getStaticRoutingList ({commit, state}, loadingOpt) {
    const res = {code: 'nok'}
    commit('resetStaticRoutingList')
    const {code, result} = await this.$axios.$get(state.apiUrlPath['staticRoutings'], loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      res.code = 'ok'
      // commit for staticRouting
      commit('setStaticRoutingList', result)
    }
    return res
  },
  async addStaticRoutingData ({commit, state}) {
    const addParam = {
      type: state.staticRouting.type,
      multipath: state.staticRouting.multipath,
      dest_addr: state.staticRouting.dest_addr,
      dest_mask: Number(state.staticRouting.dest_mask),
      metric: state.staticRouting.metric,
      flag: state.staticRouting.flag,
      gw: [],
      gwTostring: _.toString(_.map(state.staticRouting.gw, 'addr')),
      desc: state.staticRouting.desc
    }
    // remove id of gw
    const gwState = _.cloneDeep(state.staticRouting.gw)
    for (const gwData of gwState) {
      if (addParam.multipath === 1) {
        addParam.gw.push(
          {
            addr: gwData.addr,
            ifc_id: gwData.ifc_id,
            ifc_name: gwData.ifc_name,
            weight: gwData.weight
          }
        )
      } else {
        addParam.gw.push(
          {
            addr: gwData.addr
          }
        )
      }
    }
    const {code, result} = await this.$axios.$post(state.apiUrlPath['staticRoutings'], addParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('addStaticRoutingList', result)
      return true
    } else {
      return false
    }
  },
  async edtStaticRoutingData  ({commit, state}) {
    const edtParam = _.cloneDeep(state.staticRouting)
    edtParam.dest_mask = Number(edtParam.dest_mask)
    delete edtParam.id
    const apiUrl = `${state.apiUrlPath['staticRoutings']}/${state.staticRouting.id}`
    const {code, result} = await this.$axios.$put(apiUrl, edtParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('edtStaticRoutingList', result)
      return true
    } else {
      return false
    }
  },
  async delStaticRoutingList  ({commit, state}, param) {
    // apply partialError.
    const res = {code: 'nok'}
    // multi delete
    const delParam = {items: []}
    for (const idx of param.idList) {
      delParam.items.push({id: idx.id, pokName: idx.pokName})
    }
    let rslt
    if (param.idList !== undefined && param.idList.length === 1) {
      // single
      rslt = await this.$axios.$delete(`${state.apiUrlPath['staticRoutings']}/${param.idList[0].id}`)
    } else {
      // multi
      rslt = await this.$axios.$delete(state.apiUrlPath['staticRoutings'], {data: delParam})
    }
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      commit('delStaticRoutingList', param.itemIndexList)
      res.code = 'ok'
      return res
    } else {
      res.code = rslt.code
      res.errors = rslt.result.errors
      return res
    }
  },
  async getStaticRoutingCandidate ({commit, state}) {
    const res = {code: 'nok'}
    const {code, result} = await this.$axios.$get(state.apiUrlPath['staticRouteCandidates'])
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setStaticRouteCandidates', result)
    }
    return res
  },
  addStaticRoutingGw ({commit, state}, multiPath) {
    const res = {code: 'ok'}
    const addItem = _.cloneDeep(state.staticRoutingGw)
    // TEST CODE
    addItem.id = _.random(100, 10000)
    if (multiPath === 0) {
      // just gw addr
      delete addItem.ifc_id
      delete addItem.ifc_name
      delete addItem.weight
    }
    commit('addStaticRoutingGw', addItem)
    return res
  },
  editStaticRoutingGw ({commit, state}, multiPath) {
    const res = {code: 'ok'}
    const editItem = _.cloneDeep(state.staticRoutingGw)
    if (multiPath === 0) {
      // just gw addr
      delete editItem.ifc_id
      delete editItem.ifc_name
      delete editItem.weight
    }
    commit('editStaticRoutingGw', editItem)
    return res
  },
  delStaticRoutingGw ({commit, state}, param) {
    const res = {code: 'ok'}
    commit('delStaticRoutingGw', param.itemIndexList)
    return res
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> dynamic routing
  async getDynamicRoutingList ({commit, state}, loadingOpt) {
    const res = {code: 'nok'}
    commit('resetDynamicRoutingList')
    const {code, result} = await this.$axios.$get(state.apiUrlPath['dynamicRoutings'], loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      res.code = 'ok'
      // commit for dynamicRouting
      commit('setDynamicRoutingList', result)
    }
    return res
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> direct routing
  async getDirectRoutingList ({commit, state}, loadingOpt) {
    const res = {code: 'nok'}
    commit('resetDirectRoutingList')
    const {code, result} = await this.$axios.$get(state.apiUrlPath['directRoutings'], loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      res.code = 'ok'
      // commit for directRouting
      commit('setDirectRoutingList', result)
    }
    return res
  }
}

export const getters = {
}

export const strict = false
